import { createContext, useContext } from 'react';

/**
 * True inside V2 dark surfaces (every `Modal`). Shared form controls such as CustomInput and
 * FormSelect read it to switch to dark styling without changing the light pages that use them.
 */
export const DarkFormContext = createContext(false);

export const useIsDarkForm = () => useContext(DarkFormContext);
